import * as parse5 from 'parse5'
import { ParsedContent } from '@interfaces/home'
import React from 'react'
import { BrandVars } from '@quark/theme'
import logger from '@utils/logger'
import styles from './CardContent.module.scss'

export const nodeToReactElement = (
  node: any,
  key: number = 0,
  isTitle: boolean = false,
  isDriveSection: boolean = false
): React.ReactNode => {
  if (!node) return null

  if (node.nodeName === '#text') {
    return node.value || ''
  }

  if (node.nodeName === 'br') {
    return <br key={key} />
  }

  if (node.nodeName === 'strong') {
    return (
      <strong
        key={key}
        style={{
          ['--strongColor' as any]: isTitle
            ? '#15803D'
            : isDriveSection
              ? BrandVars.text['base/primary']
              : BrandVars.text['accent/textBrand-dark'],
        }}
        className={`${styles.strongText} ${!isTitle ? styles.isBolder : ''}`}>
        {node.childNodes?.map((child: any, idx: number) => nodeToReactElement(child, idx, isTitle, isDriveSection))}
      </strong>
    )
  }

  if (node.childNodes && node.childNodes.length > 0) {
    return (
      <React.Fragment key={key}>
        {node.childNodes.map((child: any, idx: number) => nodeToReactElement(child, idx, isTitle, isDriveSection))}
      </React.Fragment>
    )
  }

  return null
}

export const parseHtmlContent = (htmlString: string, isDriveSection: boolean = false): ParsedContent => {
  const defaultContent: ParsedContent = { titles: null, titlesArray: [], subtitles: null }

  if (!htmlString) return defaultContent

  try {
    const document = parse5.parseFragment(htmlString)

    const findElements = (node: any, tagName: string): any => {
      if (!node) return null
      const elements: any[] = []
      const iterateElements = (node: any, tagName: string): any => {
        if (!node) return
        if (node.nodeName === tagName) {
          elements.push(node)
          return
        }
        if (node.childNodes) {
          node.childNodes.forEach((child: any) => iterateElements(child, tagName))
        }
      }
      iterateElements(node, tagName)
      return elements
    }

    const h4Elements = findElements(document, 'h4')
    const pElements = findElements(document, 'p')

    let titles: React.ReactNode = null
    const titlesArray: React.ReactNode[] = []
    let subtitles: React.ReactNode = null

    if (h4Elements.length > 0) {
      titles = (
        <React.Fragment key="H4">
          {h4Elements.map((element: any, idx: number) => nodeToReactElement(element, idx, true, isDriveSection))}
        </React.Fragment>
      )
      // Extract individual titles for animation
      h4Elements.forEach((element: any, idx: number) => {
        titlesArray.push(nodeToReactElement(element, idx, true, isDriveSection))
      })
    }

    if (pElements.length > 0) {
      subtitles = (
        <React.Fragment key="P">
          {pElements.map((element: any, idx: number) => nodeToReactElement(element, idx, false, isDriveSection))}
        </React.Fragment>
      )
    }

    return { titles, titlesArray, subtitles }
  } catch (error) {
    logger.error('Error parsing HTML content:', error)
    return defaultContent
  }
}
